import { DateTime } from 'luxon';
import { useGetForecastRetirement } from '../api/pension-robot/useGetForecastRetirement';
import { useGetPensionCalcData } from '../api/pension-robot/useGetPensionCalcData';
import { DEFAULT_PENSION_AGE, MIN_AGE_CLIENT } from '../config/constants';


export const useGetPerMonthFactorValues = (userAge: number) => {
    // while user is typing no request should be made for ages lower than minimal age
    const usedUserAge = userAge < MIN_AGE_CLIENT ? MIN_AGE_CLIENT : userAge;
    const pensionCalcData = useGetPensionCalcData();
    const legalRetirementAge = pensionCalcData.data?.legalRetirementAge ?? DEFAULT_PENSION_AGE;
    const pensionDate = DateTime.now().plus({ years: Math.max(legalRetirementAge - usedUserAge, 0) });
    const query = useGetForecastRetirement(
        {
            riskProfileId: 8,
            paymentSingleAmount: 100,
            paymentRecurringAmount: 0,
            paymentRecurringInterval: 'Month',
            investmentEndDate: pensionDate.toISODate(),
            automaticRiskReduction: false,
            retirementPeriodInYears: 20
        },
        !!legalRetirementAge
    );
    return query;
};
